(function ($) {
    'use strict';

    $('.js-password-reveal').each(function () {
        var $t = $(this);
        var $input = $t.siblings('input[type=password]');

        $t.on('click', function () {
            $input.attr('type', $input.attr('type') === 'password' ? 'text' : 'password');
        });
    });
}) (jQuery);
